
import { defineComponent, PropType } from "vue";
import { Milestone } from "../model/Project";
import ListItem from "./ListItem.vue";

export default defineComponent({
  components: { ListItem },
  name: "Milestone",
  props: {
    name: String,
    totalFunding: Number,
    value: {
      type: Object as PropType<Milestone>,
      required: true,
    },
  },
  methods: {
    allocChanged: function (event: InputEvent) {
      let target = event.target as HTMLInputElement;
      this.$emit("allocChanged", parseInt(target.value));
    },
    dateChanged: function (event: InputEvent) {
      let target = event.target as HTMLInputElement;
      this.$emit("dateChanged", Date.parse(target.value));
    },
  },
});
